import { useLocation } from "react-router-dom";

export default function AnonimSimulationViewerPage() {
    const location = useLocation();
    console.log(window.location.host + location)
    const UrlQueryStrings = location.search;
    const index = UrlQueryStrings.indexOf("=")
    const link = UrlQueryStrings.slice(index + 1)
    console.log(link)

  return (
    <div className="embed-responsive embed-responsive-4by3">
    {
      <iframe
        id="iframe"
        className="col-lg-12"
        src={"https://www.orthomagic.com.tr/simulation.html?mlink=https://www.orthomagic.com.tr/onyxceph_simulations/" + link}>
        </iframe>
    }
  </div>
  );
}